import type ExtendedPropertyUri from 'owa-service/lib/contract/ExtendedPropertyUri';
import { getExtendedPropertyUri } from 'owa-service/lib/ServiceRequestUtils';

/** Extended property that holds the value for ConflictResolution */
export const ConflictResolutionExtendedProperty: ExtendedPropertyUri = getExtendedPropertyUri(
    'fe19a916-6e4c-4c23-99a8-528c3a6a5e55',
    'AsyncScheduling.ConflictResolution',
    'String'
);
